export default {
  init() {

  },
  finalize() {
    const $donationsWidget = $('.widget_wc-donation-widget');

    if ($donationsWidget.length > 0) {

      $donationsWidget.find('style').remove();

      // make donation amount fields tabbable
      $donationsWidget.find('.wc-label-button').attr('tabindex', 0);

      $donationsWidget.find('.wc-label-button').on('keydown', function(e) {
        if (e.keyCode == 13 || e.keyCode == 32) {
          e.preventDefault();

          $(this).find('input').trigger('click');
        }
      });

      // make cause select fields tabbable
      $donationsWidget.find('.causes-dropdown li').each(function() {
        $(this).attr('tabindex', 0);

        $(this).on('keydown', function(e) {
          if (e.keyCode == 13 || e.keyCode == 32) {
            e.preventDefault();

            $(this).trigger('click');
          }
        });
      });

    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/donations.js